'use client';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { 
    Box, 
    Container, 
    Typography, 
    Button,
    useTheme,
} from '@mui/material';
import RocketLaunchOutlinedIcon from '@mui/icons-material/RocketLaunchOutlined';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import { useFeatureFlags } from '../../contexts/FeatureFlagContext';

// Set this to true when you have real testimonials to display
const SHOW_TESTIMONIALS = false;

// Placeholder for real testimonials - add them here when available
// const testimonials = [
//   {
//     name: 'Real User',
//     location: 'City, State',
//     avatar: 'R',
//     rating: 5,
//     text: "Real testimonial text here...",
//   },
// ];

export default function SocialProofSection() {
  const { isEnabled } = useFeatureFlags();
  const regOpen = isEnabled('registration_open');
    const theme = useTheme();
    const navigate = useNavigate();

    // Early Access message when no real testimonials
    if (!SHOW_TESTIMONIALS) {
        return (
            <Box sx={{ py: { xs: 8, md: 12 }, backgroundColor: 'grey.50' }}>
                <Container maxWidth="md">
                    <Box 
                        sx={{ 
                            textAlign: 'center',
                            p: { xs: 4, md: 6 },
                            borderRadius: '24px',
                            background: `linear-gradient(135deg, ${theme.palette.primary.main}08 0%, ${theme.palette.secondary.main}08 100%)`,
                            border: `1px solid ${theme.palette.primary.main}20`,
                        }}
                    >
                        <Box
                            sx={{
                                display: 'inline-flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                width: '80px',
                                height: '80px',
                                background: 'transparent',
                                border: `2px solid ${theme.palette.primary.main}`,
                                borderRadius: '20px',
                                mb: 3,
                                color: theme.palette.primary.main,
                            }}
                        >
                            <RocketLaunchOutlinedIcon sx={{ fontSize: '2.5rem' }} />
                        </Box>

                        <Typography
                            variant="h3"
                            sx={{
                                fontSize: { xs: '1.75rem', md: '2.25rem' },
                                fontWeight: 700,
                                mb: 2,
                                color: 'grey.900',
                            }}
                        >
                            Be an Early Adopter
                        </Typography>
                        
                        <Typography
                            variant="body1"
                            sx={{
                                fontSize: '1.1rem',
                                color: 'grey.600',
                                maxWidth: 500,
                                mx: 'auto',
                                mb: 4,
                                lineHeight: 1.7,
                            }}
                        >
                            We're building something new—the first platform that combines powerful trip planning with a vibrant travel community. Join us from the start.
                        </Typography>

                        <Button
                            variant="contained"
                            size="large"
                            onClick={() => navigate(regOpen ? '/signup' : '/early-access')}
                            endIcon={<ArrowForwardIcon />}
                            sx={{
                                px: 4,
                                py: 1.5,
                                borderRadius: '30px',
                                fontWeight: 'bold',
                                textTransform: 'none',
                                fontSize: '1.1rem',
                                background: `linear-gradient(135deg, ${theme.palette.primary.main} 0%, ${theme.palette.secondary.main} 100%)`,
                                boxShadow: '0 8px 25px rgba(0, 0, 0, 0.15)',
                                '&:hover': {
                                    boxShadow: '0 12px 35px rgba(0, 0, 0, 0.2)',
                                },
                            }}
                        >
                            Get Early Access
                        </Button>
                    </Box>
                </Container>
            </Box>
        );
    }

    // TODO: When SHOW_TESTIMONIALS is true, render real testimonials here
    // For now, return the early access section
    return null;
}
